/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DropFollowStatus } from './DropFollowStatus';
import {
    DropFollowStatusFromJSON,
    DropFollowStatusFromJSONTyped,
    DropFollowStatusToJSON,
    DropFollowStatusToJSONTyped,
} from './DropFollowStatus';
import type { LedgerOwner } from './LedgerOwner';
import {
    LedgerOwnerFromJSON,
    LedgerOwnerFromJSONTyped,
    LedgerOwnerToJSON,
    LedgerOwnerToJSONTyped,
} from './LedgerOwner';

/**
 * 
 * @export
 * @interface DropFollowResponse
 */
export interface DropFollowResponse {
    /**
     * 
     * @type {string}
     * @memberof DropFollowResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DropFollowResponse
     */
    dropId: string;
    /**
     * 
     * @type {string}
     * @memberof DropFollowResponse
     */
    userId: string;
    /**
     * 
     * @type {DropFollowStatus}
     * @memberof DropFollowResponse
     */
    status: DropFollowStatus;
    /**
     * 
     * @type {number}
     * @memberof DropFollowResponse
     */
    followedAt?: number;
    /**
     * 
     * @type {string}
     * @memberof DropFollowResponse
     */
    onboardingExperienceId?: string;
    /**
     * 
     * @type {LedgerOwner}
     * @memberof DropFollowResponse
     */
    ledgerOwner?: LedgerOwner;
    /**
     * 
     * @type {string}
     * @memberof DropFollowResponse
     */
    declaredCountry?: string;
    /**
     * 
     * @type {string}
     * @memberof DropFollowResponse
     */
    declaredState?: string;
    /**
     * 
     * @type {number}
     * @memberof DropFollowResponse
     */
    acceptedTermsAt?: number;
    /**
     * 
     * @type {string}
     * @memberof DropFollowResponse
     */
    termsVersion?: string;
    /**
     * 
     * @type {number}
     * @memberof DropFollowResponse
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof DropFollowResponse
     */
    updatedAt: number;
}



/**
 * Check if a given object implements the DropFollowResponse interface.
 */
export function instanceOfDropFollowResponse(value: object): value is DropFollowResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('dropId' in value) || value['dropId'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function DropFollowResponseFromJSON(json: any): DropFollowResponse {
    return DropFollowResponseFromJSONTyped(json, false);
}

export function DropFollowResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DropFollowResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'dropId': json['dropId'],
        'userId': json['userId'],
        'status': DropFollowStatusFromJSON(json['status']),
        'followedAt': json['followedAt'] == null ? undefined : json['followedAt'],
        'onboardingExperienceId': json['onboardingExperienceId'] == null ? undefined : json['onboardingExperienceId'],
        'ledgerOwner': json['ledgerOwner'] == null ? undefined : LedgerOwnerFromJSON(json['ledgerOwner']),
        'declaredCountry': json['declaredCountry'] == null ? undefined : json['declaredCountry'],
        'declaredState': json['declaredState'] == null ? undefined : json['declaredState'],
        'acceptedTermsAt': json['acceptedTermsAt'] == null ? undefined : json['acceptedTermsAt'],
        'termsVersion': json['termsVersion'] == null ? undefined : json['termsVersion'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
    };
}

export function DropFollowResponseToJSON(json: any): DropFollowResponse {
    return DropFollowResponseToJSONTyped(json, false);
}

export function DropFollowResponseToJSONTyped(value?: DropFollowResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'dropId': value['dropId'],
        'userId': value['userId'],
        'status': DropFollowStatusToJSON(value['status']),
        'followedAt': value['followedAt'],
        'onboardingExperienceId': value['onboardingExperienceId'],
        'ledgerOwner': LedgerOwnerToJSON(value['ledgerOwner']),
        'declaredCountry': value['declaredCountry'],
        'declaredState': value['declaredState'],
        'acceptedTermsAt': value['acceptedTermsAt'],
        'termsVersion': value['termsVersion'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
    };
}

